import { VACANCY } from "./Actions";
import { api, APIS } from "../config/Config";

export function vacancyAction() {
  return async function (dispatch) {
    let res;
    try {
      dispatch({ type: VACANCY.LOADING });
      res = await api(`${APIS.vacancy}`);

      // console.log("res", res);
      const { success, data } = res.data;

      if (success === "true") {
        dispatch({ type: VACANCY.SUCCESS, payload: data.data });
      } else {
        dispatch({ type: VACANCY.ERROR });
      }
    } catch ({ message }) {
      dispatch({ type: VACANCY.ERROR });
      console.error(message);
      return 0;
    }
  };
}
